import { posthogEventResourceGroupSelected } from "~/utils/posthog/resources";
import { addInitialFunction } from "./dfm5";
import { posthogPageviewEvent } from "~/utils/posthog/general";

$(() => {
  addInitialFunction(posthogPageviewEvent);

  // Also send a page view event if we've navigated here via the bfcache
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      posthogPageviewEvent();
    }
  });

  renderResourceList();
});

function renderResourceList() {
  const list = document.querySelector(".rmets__resource-list");
  const resourcesToDisplay = resources.filter(function (resource) {
    return !!resource.rid && !!resource.title;
  });
  if (resourcesToDisplay.length === 0) {
    document.getElementById("rmets__resource-list-intro").style.display =
      "none";
  }
  for (let i = 0; i < resourcesToDisplay.length; i++) {
    const resource = resourcesToDisplay[i];

    // Create resource item with link
    const item = document.createElement("a");
    const href = `/downloadables.php?rid=${resource.rid}`;
    item.className = "rmets__resource-item";
    item.href = href;
    item.addEventListener("click", function (e) {
      e.preventDefault();
      posthogEventResourceGroupSelected({
        triggerId: "rmets-resource-item",
        groupType: "resource",
        resource,
      });
      window.location = href;
    });

    // Resource icon
    const itemIcon = document.createElement("img");
    itemIcon.src = "/images/downloadables_icon.svg";
    itemIcon.className = "rmets__resource-item__icon";

    // Resource text container
    const itemText = document.createElement("div");
    itemText.className = "rmets__resource-item__text-container";

    // Text showing resource path
    const itemPath = document.createElement("span");
    const pathStrings = JSON.parse(resource.pathcache).map((p) => p.name);
    const pathStringJoined = pathStrings.join(" | ") + " | " + resource.topic;
    itemPath.innerHTML = pathStringJoined;
    itemPath.className = "rmets__resource-item__path";

    // Text showing resource title
    const itemTitle = document.createElement("span");
    itemTitle.innerHTML = resource.title;
    itemTitle.className = "rmets__resource-item__title";

    // Compile the element and append to the list
    itemText.append(itemPath);
    itemText.append(itemTitle);
    item.append(itemIcon);
    item.append(itemText);
    list.append(item);
  }
}
